module.exports = __webpack_public_path__ + "img/martini.e54e0c39.png";